import React, {Component} from 'react'
import styled from 'styled-components'
import { Container } from 'bloomer'

import HeaderTitle from 'components/HeaderTitle'
import Header from 'components/Header'

const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

export default class BaseLayout extends Component {

  renderLoading() {
    return <p>Loading...</p>
  }

  renderError() {
    return <p>Error...</p>
  }

  render() {
    const {children, title, loading, error} = this.props

    return (
      <Main>
        <Header title={loading ? () => <HeaderTitle>Carregando...</HeaderTitle> : title} />
        <Container style={{marginTop: '1.25rem'}}>
          {loading
            ? this.renderLoading()
            : error
              ? this.renderError()
              : children
          }
        </Container>
      </Main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/BaseLayout.js